import React, { useState, useEffect } from 'react';
import axios from 'axios';

function DashboardCard08({ stockSymbol }) {
  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanyData = async () => {
      if (!stockSymbol) {
        console.error('No stockSymbol provided');
        setLoading(false);
        return;
      }
      try {
        const response = await axios.get(`https://investorverden.onrender.com/api/company?q=${stockSymbol}`);
        console.log('API response:', response.data); // Log for debugging

        if (response.data) {
          setCompanyData(response.data); // Set the company data
        } else {
          console.error('No company data found');
          setCompanyData(null);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching company data:', error);
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, [stockSymbol]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!companyData) {
    return (
      <div className="flex flex-col col-span-full sm:col-span-6 bg-white dark:bg-gray-800 shadow-sm rounded-xl">
        <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 flex items-center">
          <h2 className="font-semibold text-gray-800 dark:text-gray-100">No Risk Data Available</h2>
        </header>
      </div>
    );
  }

  const {
    auditRisk,
    boardRisk,
    compensationRisk,
    shareHolderRightsRisk,
    overallRisk,
  } = companyData;

  return (
    <div className="flex flex-col col-span-full sm:col-span-12 bg-white dark:bg-gray-800 shadow-sm rounded-xl">
    <header className="px-5 py-4 flex items-center">
      <h2 className="font-semibold text-gray-800 dark:text-gray-100">Virksomhedens risiko oversigt</h2>
    </header>

      <div className="px-5 py-4 overflow-x-auto">
        <table className="min-w-full table-auto">
          <thead>
            <tr>
              <th className="px-4 py-2 text-left border-b">Risiko type</th>
              <th className="px-4 py-2 text-left border-b">
              <div className="relative group flex items-center gap-1">
  Værdi
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 text-gray-500">
    <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
  </svg>
  <div className="absolute invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-300 top-full -left-20 mt-2 px-3 py-1 text-xs text-white bg-gray-900 rounded-lg whitespace-nowrap z-10">
    Risiko skala: 1-3 (Lav), 4-6 (Moderat), 7-10 (Høj)
    <div className="absolute bottom-full left-24 border-8 border-transparent border-b-gray-900"></div>
  </div>
</div>
</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border-t px-4 py-2">Revisionsrisiko</td>
              <td className="border-t px-4 py-2">{auditRisk}</td>
            </tr>
            <tr>
              <td className="border-t px-4 py-2">Bestyrelsesrisiko</td>
              <td className="border-t px-4 py-2">{boardRisk}</td>
            </tr>
            <tr>
              <td className="border-t px-4 py-2">Kompensationsrisiko</td>
              <td className="border-t px-4 py-2">{compensationRisk}</td>
            </tr>
            <tr>
              <td className="border-t px-4 py-2">Risiko for aktionærrettigheder</td>
              <td className="border-t px-4 py-2">{shareHolderRightsRisk}</td>
            </tr>
            <tr>
              <td className="border-t px-4 py-2">Samlet risiko</td>
              <td className="border-t px-4 py-2">{overallRisk}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DashboardCard08;
